import { render } from "./TokenExpiryModalComponent.vue?vue&type=template&id=29b977ee"
import script from "./TokenExpiryModalComponent.vue?vue&type=script&lang=js"
export * from "./TokenExpiryModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__